import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import YouTube from 'react-youtube';
import auth from '../auth/auth.js'
const AddTabs = () => {
  const [youtubeLink, setYoutubeLink] = useState('');
  const [message, setMessage] = useState('');
  const [tablatures, setTablatures] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editTabId, setEditTabId] = useState(null);

  const login = (JSON.parse(localStorage.getItem('user')) || {}).login;

  // États pour gérer le formulaire, les messages et les données des tablatures
  const [tabData, setTabData] = useState({
    title: '',
    artist: '',
    genre: '',
    description: '',
    pdfFile: null,
    youtubeLink: '',
  });

  // Gestion des changements dans les champs de formulaire
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'youtubeLink') {
      setYoutubeLink(value);
    }
    setTabData({
      ...tabData,
      [name]: files ? files[0] : value,
    });
  };

  // Commence l'édition d'une tablature
  const handleEdit = (tabId) => {
    setIsEditing(true);
    setEditTabId(tabId);

    const tabToEdit = tablatures.find((tab) => tab._id === tabId);
    if (tabToEdit) {
      setTabData({
        title: tabToEdit.title,
        artist: tabToEdit.artist,
        genre: tabToEdit.genre,
        pdfFile: null,
        youtubeLink: tabToEdit.youtubeLink,
        description: tabToEdit.description,
      });
    }
  };

  // Annule l'édition d'une tablature
  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditTabId(null);
    setTabData({
      title: '',
      artist: '',
      genre: '',
      pdfFile: null,
      youtubeLink: '',
      description: '',
    });
  };

  // Modifie une tablature
  const handleUpdate = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', tabData.title);
    formData.append('artist', tabData.artist);
    formData.append('genre', tabData.genre);
    if (tabData.pdfFile) {
      formData.append('pdfFile', tabData.pdfFile);
    }
    formData.append('youtubeLink', tabData.youtubeLink);
    formData.append('description', tabData.description);

    axios
      .put(`${process.env.REACT_APP_API}/update-tabs/${editTabId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          ...auth(),
        },
      })
      .then((response) => {
        console.log('Tablature modifiée avec succès:');
        setMessage('Tablature modifiée avec succès');
        setIsEditing(false);
        setEditTabId(null);
        setTabData({
          title: '',
          artist: '',
          genre: '',
          pdfFile: '',
          youtubeLink: '',
          description: '',
        });

        axios.get(`${process.env.REACT_APP_API}/tabs`).then((response) => {
          setTablatures(response.data);
        });
      })
      .catch((error) => {
        console.log('Erreur lors de la modification de la tablature');
        setMessage('Erreur lors de la modification de la tablature');
      });
  };

  // Supprime une tablature
  const handleDelete = (tabId) => {
    axios
      .delete(`${process.env.REACT_APP_API}/delete-tabs/${tabId}`, { headers: auth() })
      .then((response) => {
        console.log(response.data);
        axios.get(`${process.env.REACT_APP_API}/tabs`).then((response) => {
          setTablatures(response.data);
        });
      })
      .catch((error) => {
        console.log('Erreur lors de la suppression de la tablature:');
      });
  };

// Soumet un nouveau formulaire d'ajout de tablature
const handleSubmit = (e) => {
  e.preventDefault();
  const formData = new FormData();
  formData.append('title', tabData.title);
  formData.append('artist', tabData.artist);
  formData.append('genre', tabData.genre);
  formData.append('pdfFile', tabData.pdfFile);
  formData.append('youtubeLink', tabData.youtubeLink);
  formData.append('description', tabData.description);

  axios
    .post(`${process.env.REACT_APP_API}/add-tabs`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        ...auth(), 
      },
    })
    .then((response) => {
      console.log('Tablature créée avec succès:', response.data);
      setMessage('Tablature ajoutée avec succès');
      setTabData({
        title: '',
        artist: '',
        genre: '',
        pdfFile: null,
        youtubeLink: '',
        description: '',
      });

      axios.get(`${process.env.REACT_APP_API}/tabs`, { headers: auth() }).then((response) => {
        setTablatures(response.data);
      });
    })
    .catch((error) => {
      console.log('Erreur lors de la création de la tablature:');
      setMessage(`Erreur lors de la création de la tablature: ${error.message}`);
    });
};


  // Récupère la liste des tablatures lors du chargement de la page
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/tabs`)
      .then((response) => {
        setTablatures(response.data);
      })
      .catch((error) => {
        console.log('Erreur lors de la récupération des tablatures:');
      });
  }, []);

  const getYouTubeVideoId = (url) => {
    const patterns = [
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
      /^([a-zA-Z0-9_-]{11})$/,
    ];

    for (const pattern of patterns) {
      const match = url.match(pattern);
      if (match) {
        return match[1];
      }
    }

    return '';
  };

  return (
<main className="main-tablature">
  <section className="tablature-section">
    <h1 className="heading">Ajouter ou éditer une tablature</h1>
    <form onSubmit={isEditing ? handleUpdate : handleSubmit}>
      <section className="form-group">
        <label htmlFor="title">Titre :</label>
        <input
          type="text"
          id="title"
          name="title"
          value={tabData.title}
          onChange={handleInputChange}
        />
      </section>

      <section className="form-group">
        <label htmlFor="artist">Artiste :</label>
        <input
          type="text"
          id="artist"
          name="artist"
          value={tabData.artist}
          onChange={handleInputChange}
        />
      </section>

      <section className="form-group">
        <label htmlFor="genre">Genre :</label>
        <input
          type="text"
          id="genre"
          name="genre"
          value={tabData.genre}
          onChange={handleInputChange}
        />
      </section>

      <section className="form-group">
        <label htmlFor="pdfFile">Fichier PDF :</label>
        <input
          type="file"
          id="pdfFile"
          name="pdfFile"
          accept=".pdf"
          onChange={handleInputChange}
        />
      </section>

      <section className="form-group">
        <label htmlFor="youtubeLink">Lien YouTube :</label>
        <input
          type="text"
          id="youtubeLink"
          name="youtubeLink"
          value={tabData.youtubeLink}
          onChange={handleInputChange}
        />
        {tabData.youtubeLink && (
          <article className="form-group">
            <YouTube videoId={getYouTubeVideoId(tabData.youtubeLink)} />
          </article>
        )}
      </section>

      <section className="form-group">
        <label htmlFor="description">Description :</label>
        <textarea
          id="description"
          name="description"
          value={tabData.description}
          onChange={handleInputChange}
        ></textarea>
      </section>

      <section className="form-group">
        <label htmlFor="username">Utilisateur :</label>
        <input
          type="text"
          id="username"
          name="username"
          value={login}
          readOnly
        />
      </section>

      <button className="add-edit-btn" type="submit">
        {isEditing ? 'Modifier' : 'Ajouter'}
      </button>
      {isEditing && (
        <button
          className="cancel-btn"
          type="button"
          onClick={handleCancelEdit}
        >
          Annuler
        </button>
      )}
    </form>
    <p>{message}</p>
  </section>

  <section className="tablature-list">
    <h2 className="heading">Liste des tablatures ajoutées :</h2>
    <ul>
      {tablatures.map((tab) => (
        <article key={tab._id} className="tablature-item">
          <p>Titre: {tab.title}</p>
          <p>Artiste: {tab.artist}</p>
          <p>Genre: {tab.genre}</p>
          <p>YouTube Link: {tab.youtubeLink}</p>
          <p>Description: {tab.description}</p>

          <button className="edit-btn" onClick={() => handleEdit(tab._id)}>
            Modifier
          </button>
          <button
            className="delete-btn"
            onClick={() => handleDelete(tab._id)}
          >
            Supprimer
          </button>
        </article>
      ))}
    </ul>
  </section>
</main>

  );
};

export default AddTabs;
